// extracted by mini-css-extract-plugin
export default {"component":"NewOfficeModal_component__F5+ne","modalContainer":"NewOfficeModal_modalContainer__n-Ich","input":"NewOfficeModal_input__h2iJ3"};